export default {
  "Cut Audio": "오디오 자르기",
  "HitPaw Online Audio Cutter": "HitPaw 온라인 오디오 커터",
  "Trim or cut any audio files online.": "온라인으로 오디오 파일을 자르거나 잘라냅니다.",
  "Cut": "자르기",
  "Fade in": "페이드인",
  "Fade out": "페이드아웃",
  "Cut from": "에서 잘라내기",
  "to": "까지",
  "Extract selection": "선정 내용 추출하기",
  "Delete selection": "선정  내용 삭제하기",
  "Adjust New": "새로 조정하기",
  "Cut New": "새로 자르기",
  "Adjust Volume": "볼륨 조정",
  "HitPaw Online Volume Changer": "HitPaw 온라인 볼륨 조절기",
  "Turn up or Turn down the volume of audio.": "오디오 볼륨을 높이거나 낮춥니다.",
  "Volume": "볼륨",
  "Change Speed": "속도 조정하기",
  "HitPaw Online Audio Speed Changer": "HitPaw 온라인 오디오 속도 조절기",
  "Speed up or slow down audios online easily.": "온라인 오디오의 속도를 쉽게 올리거나 줄입니다.",
  "Speed": "속도",
  "Format": "형식",
  "Size": "사이즈",
  "Duration": "기간",
};
